module.exports = __webpack_public_path__ + "img/wolf_7.4d651aa4.jpg";